import { useRouter } from 'next/router';

import type { Activity } from 'models/Activity';

import { useCitySelection } from 'hooks/useCitySelection';
import { useGetProductBySlug } from 'hooks/useGetProductBySlug';
import { useSWRGet } from 'hooks/useSWRGet';

import { getQueryParamAsString } from 'utils/getQueryParamAsString';

import { useProduct } from 'templates/Product/useProduct';

export const useSubproduct = () => {
  const router = useRouter();
  const { location } = useCitySelection();
  const { selectedSubproduct } = useProduct();

  const { data: productData } = useGetProductBySlug(
    getQueryParamAsString(router.query.slug),
  );

  const { data, error } = useSWRGet<Activity[]>(
    productData?.isTypology &&
      !!location?.areaid &&
      `typology/${productData.activityId}/activities?locationid=${location.areaid}`,
    'attendence',
  );

  const { data: subproductData, error: subproductError } = useSWRGet<Activity>(
    productData?.isTypology &&
      !!selectedSubproduct?.activityId &&
      !!location?.areaid &&
      `/typology/${productData.activityId}/activities/${selectedSubproduct.activityId}?locationid=${location.areaid}`,
    'attendence',
  );

  if (error || subproductError) {
    router.push('/500');
  }

  return {
    data,
    error,
    subproductData,
    subproductError,
  };
};
